/* ===== Kits com cor de cada relógio (dc-packs) ===== */
(function () {
  'use strict';
  if (!document.querySelector('[data-dc-buy]')) return;
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function productForm() { return qs('.product product-form form') || qs('product-form form'); }
  function formId() { var f = productForm(); return f ? f.getAttribute('id') : null; }
  function nativeInputs() { return qsa('.product__info-container variant-selects input[type="radio"]'); }
  function nativeValue() {
    var c = nativeInputs().filter(function (i) { return i.checked; })[0];
    if (c) return c.value;
    var sel = qs('.product__info-container variant-selects select');
    return sel ? sel.value : null;
  }
  function chooseNative(val) {
    var inp = nativeInputs().filter(function (i) { return i.value === val; })[0];
    if (inp) { if (!inp.checked) inp.click(); return; }
    var sel = qs('.product__info-container variant-selects select');
    if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function paintDd(dd) {
    var name = qs('[data-dc-dd-name]', dd).textContent.trim();
    var opt = qsa('.dc-dd__opt', dd).filter(function (o) { return o.getAttribute('data-name') === name; })[0];
    var sw = qs('[data-dc-dd-sw]', dd);
    if (opt && sw) sw.setAttribute('style', qs('.dc-swatch', opt).getAttribute('style') || '');
    qsa('.dc-dd__opt', dd).forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
    var input = qs('[data-dc-prop]', dd);
    if (input) input.value = name;
  }
  function closeAll(except) {
    qsa('[data-dc-dd]').forEach(function (dd) {
      if (dd === except) return;
      var l = qs('.dc-dd__list', dd); if (l) l.hidden = true;
      var b = qs('[data-dc-dd-btn]', dd); if (b) b.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
    });
  }
  function syncColors() {
    var fid = formId(), names = [];
    qsa('[data-dc-pack]').forEach(function (p) {
      var on = p.classList.contains('is-on');
      qsa('[data-dc-prop]', p).forEach(function (inp) { inp.disabled = !on; if (fid) inp.setAttribute('form', fid); if (on) names.push(inp.value); });
    });
    var single = qs('[data-dc-single]');
    if (single) { var si = qs('[data-dc-prop]', single); if (si) { if (fid) si.setAttribute('form', fid); names.push(si.value); } }
    var pack = qs('[data-dc-pack].is-on');
    var sub = qs('[data-dc-sticky-sub]');
    if (sub && pack) sub.textContent = pack.getAttribute('data-title') + ' · ' + pack.getAttribute('data-price') + (names.length ? ' · ' + names.join(' + ') : '');
  }
  function showColorMedia(name) {
    if (!name) return;
    var low = name.toLowerCase();
    var thumb = qsa('.thumbnail-list button, .thumbnail-list .thumbnail').filter(function (b) { var img = qs('img', b); return img && (img.getAttribute('alt') || '').toLowerCase().indexOf(low) !== -1; })[0];
    if (thumb) thumb.click();
  }
  function paintPacks() {
    var val = nativeValue(); if (val === null) return;
    qsa('[data-dc-pack]').forEach(function (p) { var on = p.getAttribute('data-value') === val; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
  }
  function selectPack(pack) {
    if (!pack || pack.getAttribute('aria-disabled') === 'true') return;
    qsa('[data-dc-pack]').forEach(function (p) { var on = p === pack; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
    chooseNative(pack.getAttribute('data-value'));
    syncColors();
  }
  qsa('[data-dc-dd]').forEach(paintDd);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dc-dd-btn]');
    if (btn) {
      var dd = btn.closest('[data-dc-dd]'), list = qs('.dc-dd__list', dd), open = list.hidden;
      closeAll(dd); list.hidden = !open; dd.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var pk = btn.closest('[data-dc-pack]'); if (pk && !pk.classList.contains('is-on')) selectPack(pk);
      return;
    }
    var opt = e.target.closest('.dc-dd__opt');
    if (opt) {
      var dd2 = opt.closest('[data-dc-dd]');
      qs('[data-dc-dd-name]', dd2).textContent = opt.getAttribute('data-name');
      paintDd(dd2); closeAll(); syncColors();
      var rows = qsa('[data-dc-dd]', opt.closest('[data-dc-pack]'));
      if (rows[0] === dd2) showColorMedia(opt.getAttribute('data-name'));
      qs('[data-dc-dd-btn]', dd2).focus();
      return;
    }
    if (!e.target.closest('[data-dc-dd]')) closeAll();
    var sw = e.target.closest('[data-dc-single] .dc-sw');
    if (sw) {
      var box = sw.closest('[data-dc-single]');
      qsa('.dc-sw', box).forEach(function (s) { var on = s === sw; s.classList.toggle('is-on', on); s.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var nm = sw.getAttribute('data-name');
      var inp = qs('[data-dc-prop]', box); if (inp) inp.value = nm;
      var lab = qs('[data-dc-single-name]', box); if (lab) lab.textContent = nm;
      showColorMedia(nm); syncColors();
      return;
    }
    var pack = e.target.closest('[data-dc-pack]');
    if (pack && !e.target.closest('[data-dc-pack-colors]')) selectPack(pack);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); return; }
    var pack = e.target.closest && e.target.closest('[data-dc-pack]');
    if (pack && e.target === pack && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); selectPack(pack); return; }
    if (pack && e.target === pack && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      var all = qsa('[data-dc-pack]'), i = all.indexOf(pack) + (e.key === 'ArrowDown' ? 1 : -1);
      if (all[i]) { e.preventDefault(); all[i].focus(); selectPack(all[i]); }
    }
  });
  function refresh() { paintPacks(); syncColors(); }
  refresh();
  window.addEventListener('load', function () { setTimeout(refresh, 150); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(refresh, 80); });
  var info = qs('.product__info-container');
  if (info && 'MutationObserver' in window) {
    var tm;
    new MutationObserver(function (muts) {
      if (!muts.some(function (m) { return !(m.target.closest && m.target.closest('[data-dc-buy]')); })) return;
      clearTimeout(tm); tm = setTimeout(refresh, 60);
    }).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
  }
})();
